import { Repository, Team } from '@basehub/data/replicache/index'
import { invariant } from '@epic-web/invariant'
import { useQuery } from '@tanstack/react-query'
import {
  PublicRepo,
  PublicTeam,
} from '@basehub/data/replicache/mutators/_public-types'
import { forkOriginResultSchema } from './schema'

export const useForkOrigin = (
  repository: Repository | PublicRepo,
  team: Team | PublicTeam | null
) => {
  const forkOriginQuery = useQuery(
    ['fork-origin', repository.id],
    async () => {
      invariant(!!repository.forkStatus, 'Repository must have forkStatus')
      invariant(team, 'Team must be defined')

      const forkOrigin = await fetch(
        `/api/repo/${repository.id}/fork-origin?teamId=${team.id}`
      )
        .then((res) => res.json())
        .then((data) => forkOriginResultSchema.parse(data))

      return forkOrigin
    },
    { enabled: Boolean(repository.forkStatus && !!team) }
  )

  return forkOriginQuery
}
